import { render, staticRenderFns } from "./TakeoffRunFields.vue?vue&type=template&id=54f14587&"
import script from "./TakeoffRunFields.vue?vue&type=script&lang=ts&"
export * from "./TakeoffRunFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TakeoffRunFields.vue"
export default component.exports